import { FormProvider, useForm } from "react-hook-form";
import { Modal, MuniSpinner2, TextInput } from "../../../components"
import { useGeneralAppStore } from "../../../store/generalAppStore"
import { yupResolver } from "@hookform/resolvers/yup";
import { aprobarDenunciaSchema } from "../ModalInfraccionMCD/components/Formularios/schemas";
import React, { useEffect, useRef, useState } from "react";
import { aprobarDenuncia } from "../ModalInfraccionMCD/components/Formularios/handlers";
import { Alert } from "@mui/material";
import { Button } from "react-bootstrap";
import LocaleIcon from "../../../components/svgs/LocaleIcon";
import { Lock } from "@mui/icons-material";
import CropTestREC from "../ModalInfraccionMCD/components/Formularios/CropTestREC";

const ModalDatosMCD = (props) => {

    const { modals, handlerModal } = useGeneralAppStore();
    const { infraccion_seleccionada, datosTitular, setInfraccionesNuevas } = props;

    console.log(infraccion_seleccionada)
    console.log(datosTitular)
    const [fotoPatenteSeleccionada, setFotoPatenteSeleccionada] = useState(null);

    const [fPSeleccionada, setFPSeleccionada] = useState(null);
    const [fInfraccionSeleccionada, setFISeleccionada] = useState(null);

    const [fotoInfraccion2, setFotoInfraccion2] = useState(null);

    const VerEnGoogleMaps = ({ lat, lng }) => {
        const abrirEnGoogleMaps = () => {
            const url = `https://www.google.com/maps?q=${lat},${lng}`;
            window.open(url, '_blank');
        };

        return (
            <Button size="sm" onClick={abrirEnGoogleMaps}>
                <div className="d-flex align-items-center gap-1">
                    <span>
                        Ver ubicación en Google Maps
                    </span>
                    <LocaleIcon width={15} height={15} color="#fff" />
                </div>
            </Button>
        );
    };

    useEffect(() => {
        console.log(infraccion_seleccionada)
        console.log(infraccion_seleccionada?.fotos[fInfraccionSeleccionada])
        if (infraccion_seleccionada?.fotos[fInfraccionSeleccionada]) {
            console.log('entre')
            const b64string = infraccion_seleccionada?.fotos[fInfraccionSeleccionada]?.file.replaceAll("data:image/webp;base64,", "");
            const byteC = atob(b64string);
            const byteN = Array.from(byteC, (char) => char.charCodeAt(0));
            const byteA = new Uint8Array(byteN);
            const originalB = new Blob([byteA], { type: "image/png" });
            const fileInfraccionMCD = new File([originalB], "cropped-image-infraccion.png", { type: "image/png" });
            methods?.setValue('foto_infraccion1', fileInfraccionMCD)
            console.log(fileInfraccionMCD)
        }


    }, [fInfraccionSeleccionada])

    console.log(fInfraccionSeleccionada)

    const formRef = useRef(null);
    const methods = useForm({
        mode: "all",
        resolver: yupResolver(aprobarDenunciaSchema),
        defaultValues: {
            id: infraccion_seleccionada?.id,

            nombre: datosTitular?.razonSocial,
            // apellido_titular: datosTitular?.titular?.renaper?.apellido,
            documento: datosTitular?.documento,
            direccion_titular: datosTitular?.direccion_titular,
            // direccion_infraccion: ,
            provincia: datosTitular?.provincia,
            localidad: datosTitular?.localidad,
            codigo: datosTitular?.codigo_postal,
            // razonSocial: datosTitular?.titular?.nombre,

            patente: datosTitular?.dominio?.replaceAll("-", ""),
            marca: datosTitular?.vehiculo?.marca,
            modelo: datosTitular?.vehiculo?.modelo,

            latitud: infraccion_seleccionada.latitud,
            longitud: infraccion_seleccionada.longitud,
        },
    });


    return (
        <>
            <Modal
                show={modals.includes('datos_mcd')}
                // size={'xl'}
                onHide={() => { handlerModal({ modal: false, modalName: "datos_mcd" }) }}
                backdrop={'static'}
                fullscreen
                title={() => 'datos de la infraccion'}
            >
                <FormProvider {...methods}>
                    <div ref={formRef}></div>
                    <form
                        // className="container"
                        onSubmit={methods.handleSubmit((data) =>
                            aprobarDenuncia(data, setInfraccionesNuevas, methods.setError)
                        )}
                    >
                        <fieldset className="row  p-2" disabled={methods.formState.isSubmitting}>
                            <section className="col-3">
                                <div className="row ">
                                    <h5 className="m-0">Datos Titular</h5>
                                    <div className="col-12 col-md-12 ">
                                        <TextInput name="nombre" label="Razon Social *" />
                                    </div>
                                    <div className="col-12 col-md-6 ">
                                        <TextInput name="documento" label="Documento *" />
                                    </div>
                                    <div className="col-12 col-md-6 ">
                                        <TextInput name="codigo" label="C.P *" />
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <TextInput name="direccion_titular" label="Dirección *" />
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-6">
                                        <TextInput name="provincia" label="Provincia *" />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <TextInput name="localidad" label="Localidad *" />
                                    </div>


                                    <hr className="my-3" />
                                    <h5 className="m-0 ">Datos Vehiculo</h5>
                                    <div className="col-6 ">
                                        <TextInput name="patente" label="Patente *" />
                                    </div>
                                    <div className="col-6">
                                        <TextInput name="marca" label="Marca *" />
                                    </div>
                                    <div className="col-12 ">
                                        <TextInput name="modelo" label="Modelo *" />
                                    </div>

                                    <div className="col-12">
                                        <TextInput name="direccion_infraccion" label="Dirección de la infracción *" />
                                        <div className="mt-2">
                                            <VerEnGoogleMaps lat={infraccion_seleccionada?.latitud} lng={infraccion_seleccionada?.longitud} />
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className="col-9">

                                <div className="row">
                                    <div className="col-6">
                                        {/* <hr className="my-3" /> */}
                                        <h5 className="m-0">Imágene de la patente</h5>

                                        <Alert color="info">Seleccione y recorte la imágen de la patente</Alert>
                                        <div className="col-12  d-flex justify-content-center gap-3 mb-3" style={{ height: "60px" }}>
                                            {infraccion_seleccionada.fotos.map((foto, i) => {
                                                return (
                                                    <React.Fragment key={i}>
                                                        <img
                                                            src={foto.file}
                                                            className="image-selection  "

                                                            style={{
                                                                background: "#777",
                                                                objectFit: "contain",
                                                                aspectRatio: "3/4",
                                                                height: "100%",
                                                                opacity:
                                                                    fPSeleccionada !== null && fPSeleccionada !== i
                                                                        ? "0.5"
                                                                        : 1,
                                                                border:
                                                                    fPSeleccionada !== null && fPSeleccionada === i
                                                                        ? "2px solid var(--primary)"
                                                                        : "none",
                                                            }}
                                                            onClick={() => {
                                                                // if (fotoInfraccion2 !== null && fotoInfraccion2 === i) {
                                                                //     return;
                                                                // }
                                                                // setFotoPatenteSeleccionada(i);
                                                                if (fPSeleccionada !== null && fPSeleccionada === i) {
                                                                    return;
                                                                }
                                                                setFPSeleccionada(i);
                                                            }}
                                                        />
                                                        {/* {fPSeleccionada !== null && fPSeleccionada === i && <Lock />} */}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>


                                        {fPSeleccionada !== null ? (
                                            <div style={{ maxWidth: "500px" }} className="mx-auto">
                                                <CropTestREC
                                                    // foto={infraccion_seleccionada.fotos[fotoPatenteSeleccionada]}
                                                    foto={infraccion_seleccionada.fotos[fPSeleccionada]}
                                                    setValue={methods.setValue}
                                                    key={fPSeleccionada}
                                                    i={fPSeleccionada}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-6">
                                        {/* <hr className="my-3" /> */}
                                        <h5 className="m-0">Imágen de la infracción</h5>

                                        <Alert color="info">Seleccione y recorte la imágen de la infracción</Alert>
                                        <div className="col-12  d-flex justify-content-center gap-3 mb-3" style={{ height: "60px" }}>
                                            {infraccion_seleccionada.fotos.map((foto, i) => {
                                                return (
                                                    <React.Fragment key={i}>
                                                        <img
                                                            src={foto.file}
                                                            className="image-selection  "

                                                            style={{
                                                                background: "#777",
                                                                objectFit: "contain",
                                                                aspectRatio: "3/4",
                                                                height: "100%",
                                                                opacity:
                                                                    fInfraccionSeleccionada !== null && fInfraccionSeleccionada !== i
                                                                        ? "0.5"
                                                                        : 1,
                                                                border:
                                                                    fInfraccionSeleccionada !== null && fInfraccionSeleccionada === i
                                                                        ? "2px solid var(--primary)"
                                                                        : "none",
                                                            }}
                                                            onClick={() => {
                                                                if (fInfraccionSeleccionada !== null && fInfraccionSeleccionada === i) {
                                                                    return;
                                                                }
                                                                setFISeleccionada(i);
                                                                methods?.setValue('foto_infraccion1', infraccion_seleccionada.fotos[fInfraccionSeleccionada]?.file)
                                                                // if (fotoInfraccion2 !== null && fotoInfraccion2 === i) {
                                                                //     return;
                                                                // }
                                                                // setFotoPatenteSeleccionada(i);
                                                            }}
                                                        />
                                                        {/* {fInfraccionSeleccionada !== null && fInfraccionSeleccionada === i && <Lock />} */}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                        {
                                            fInfraccionSeleccionada !== null
                                            &&
                                            <div style={{ height: "400px", aspectRatio: "3/4", margin: "0 auto" }}>
                                                <img src={infraccion_seleccionada.fotos[fInfraccionSeleccionada]?.file} alt="imagen-infraccion" className="object-fit-cover h-100 w-100" />
                                            </div>
                                        }
                                        {/* {fInfraccionSeleccionada !== null ? (
                                            <div style={{ maxWidth: "500px" }} className="mx-auto">
                                                <CropTestREC
                                                    foto={infraccion_seleccionada.fotos[fInfraccionSeleccionada]}
                                                    setValue={methods.setValue}
                                                    key={fInfraccionSeleccionada}
                                                    i={fInfraccionSeleccionada}
                                                />
                                            </div>
                                        ) : null} */}
                                    </div>
                                </div>
                            </section>

                            <hr />
                            <div className="d-flex justify-content-center gap-4">
                                <Button size="sm" type="submit"
                                    disabled={!methods.watch('foto_infraccion1') || !methods.watch('foto_patente')}
                                >
                                    {methods.formState.isSubmitting ? (
                                        <span className="d-flex justify-content-center gap-1">
                                            <MuniSpinner2
                                                width="18px"
                                                height="18px"
                                                circularProgressSize={24}
                                                circularProgressColor="#ffffff"
                                                fileName="bola-blanca.png"
                                            />
                                        </span>
                                    ) : (
                                        "Aprobar Denuncia"
                                    )}
                                </Button>
                                <Button variant="danger" onClick={() => { handlerModal({ modal: true, modalName: "anular_denuncia" }) }}>
                                    Anular denuncia
                                </Button>
                            </div>
                        </fieldset>
                    </form>
                </FormProvider>
            </Modal>
        </>
    )
}

export default ModalDatosMCD;